<template>
  <section class="section">
    <div class="container">
      <h1 class="title">{{ $translate('translations') | capitalize }} - {{ language }}</h1>
      <div class="buttons">
        <b-button slot="trigger" class="is-primary" icon-right="content-save-outline" @click="saveTranslations" />
        <b-button slot="trigger" class="is-primary" icon-right="download" @click="downloadTranslations" />
      </div>
      <b-field grouped>
        <b-field horizontal :label="$translate('translateFrom') | capitalize">
          <b-select v-model="selectedFromLanguage" @input="changeFromLanguage()">
            <option v-for="language in fromLanguages" :key="language.name">{{ language.name }}</option>
          </b-select>
        </b-field>
        <b-field horizontal :label="$translate('translateTo') | capitalize">
          <b-select v-model="selectedToLanguage" @input="changeToLanguage()">
            <option v-for="language in fromLanguages" :key="language.name">{{ language.name }}</option>
          </b-select>
        </b-field>
        <b-field horizontal :label="$translate('section') | capitalize">
          <b-select v-model="selectedSection">
            <option v-for="(items, section) in table" :key="section">{{ section }}</option>
          </b-select>
        </b-field>
      </b-field>
      <h1 class="is-size-3">{{ selectedSection }}</h1>
      <b-field v-for="string_key in table[selectedSection]" :key="string_key">
        <b-field :label="fromLanguage[string_key] + ' (' + string_key + ')'" horizontal>
          <b-input v-model="translations[string_key]" :placeholder="$t(string_key, selectedToLanguage)"></b-input>
        </b-field>
      </b-field>
      <!--<div v-for="(data, key) in fromLanguage" :key="key">
      <b-field :label="data ? data : key" horizontal>
        <b-input v-model="translations[key]"> </b-input>
      </b-field>
      </div>-->
    </div>
  </section>
</template>

<script>
import en from '@/helpers/locales/en.json'
import it from '@/helpers/locales/it.json'
import fr from '@/helpers/locales/fr.json'
import de from '@/helpers/locales/de.json'
import dk from '@/helpers/locales/dk.json'
import table from '@/helpers/global.json'
import permissionMixin from '@/helpers/mixins/permissionMixin'

export default {
  name: 'Translations',
  mixins: [permissionMixin],
  data() {
    return {
      table: table,
      id: undefined,
      dictionaries: [],
      selectedFromLanguage: '',
      selectedToLanguage: '',
      fromLanguage: {},
      toLanguage: '',
      fromLanguages: [
        { name: 'en', dictionary: en },
        { name: 'it', dictionary: it },
        { name: 'fr', dictionary: fr },
        { name: 'de', dictionary: de },
        { name: 'dk', dictionary: dk },
      ],
      language: '',
      translations: {},
      selectedSection: '',
    }
  },
  mounted() {
    if (this.userInfo && this.userInfo.type === 'A') {
      this.language = this.$parent.loggedUser.language
      this.selectedFromLanguage = this.language
      this.selectedToLanguage = this.language
      this.changeFromLanguage()
      this.getSavedTranslations()
    } else {
      this.$router.push('/forbidden')
    }
  },
  methods: {
    changeFromLanguage() {
      this.fromLanguages.forEach(lang => {
        if (lang.name === this.selectedFromLanguage) {
          this.fromLanguage = lang.dictionary
        }
      })
    },
    changeToLanguage() {
      this.language = this.selectedToLanguage
      this.selectDictionary()
    },
    saveTranslations() {
      let found = false
      this.dictionaries.forEach(dictionary => {
        if (dictionary.language == this.selectedToLanguage) {
          found = true
        }
      })
      if (!found)
        this.dictionaries.push({
          language: this.selectedToLanguage,
          translations: this.translations,
        })
      let objectToSave = {
        email: this.userInfo.email,
        dictionaries: this.dictionaries,
        //language: this.language,
        //translations: this.translations
      }
      if (!this.id) {
        this.$db
          .collection('translations')
          .add(objectToSave)
          .then(data => {
            this.id = data.id
            this.savedConfirm()
          })
      } else {
        this.$db
          .collection('translations')
          .doc(this.id)
          .update(objectToSave)
          .then(() => {
            this.savedConfirm()
          })
      }
    },
    getSavedTranslations() {
      this.$db
        .collection('translations')
        .where('email', '==', this.userInfo.email)
        .get()
        .then(snapshot => {
          snapshot.forEach(doc => {
            this.dictionaries = doc.data().dictionaries
            this.selectDictionary()
            //this.translations = doc.data().translations;
            this.id = doc.id
          })
        })
    },
    savedConfirm() {
      this.$buefy.toast.open({
        message: 'OK',
        type: 'is-success',
      })
    },
    selectDictionary() {
      this.translations = {}
      this.dictionaries.forEach(dictionary => {
        if (dictionary.language == this.language) {
          this.translations = dictionary.translations
        }
      })
    },
    findDictionary(lang) {
      let dictionary = {}
      this.fromLanguages.forEach(language => {
        if (language.name == lang) {
          dictionary = language.dictionary
        }
      })
      return dictionary
    },
    downloadTranslations() {
      const cloneDeep = require('clone-deep')
      let jsonFile = cloneDeep(this.fromLanguages[1].dictionary)
      const nativeTranslations = this.findDictionary(this.language)
      for (let key in jsonFile) {
        if (this.fromLanguages[0].dictionary[key] && this.fromLanguages[0].dictionary[key] != '') {
          jsonFile[key] = this.fromLanguage[key]
        }
        if (nativeTranslations[key] && nativeTranslations[key] != '') {
          jsonFile[key] = nativeTranslations[key]
        }
        if (this.translations[key] && this.translations[key] != '') {
          jsonFile[key] = this.translations[key]
        }
      }

      //Object.assign(jsonFile, this.fromLanguage);
      //Object.assign(jsonFile, this.translations);
      var jsonse = JSON.stringify(jsonFile, null, '\t')
      var blob = new Blob([jsonse], { type: 'application/json' })
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = 'traduzione'
      link.click()
      URL.revokeObjectURL(link.href)
    },
  },
}
</script>
